/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import FormRow from '../../../../components/FormRow'
import FormCol from '../../../../components/FormCol'
import Typography from '@material-ui/core/Typography'
import {
  SimpleForm,
  TextInput,
  Create,
  required,
  Toolbar,
  SaveButton,
  useRefresh,
  useNotify,
  useRedirect,
  NumberInput,
  useDataProvider,
  ListButton,
  usePermissions,
} from 'react-admin'
import StyledInput from '../../../../components/StyledInput'
import { RunnersSchedule } from './RunnersSchedule'

export const CreateVisit = (props) => {
  const dataProvider = useDataProvider()
  const refresh = useRefresh()
  const notify = useNotify()
  const redirect = useRedirect()

  const [leadPropertyId, setLeadPropertyId] = useState(null)
  const [propertyId, setPropertyId] = useState(null)
  const [property, setProperty] = useState(null)

  const search = props.location?.search

  const { permissions } = usePermissions()

  useEffect(() => {
    if (props.location?.search) {
      setLeadPropertyId(new URLSearchParams(search).get('for'))
    } else {
      setLeadPropertyId(null)
    }
  }, [props.location?.search])

  useEffect(() => {
    if (!leadPropertyId) {
      setPropertyId(null)
    } else {
      dataProvider
        .getOne('leadProperties', { id: leadPropertyId })
        .then(({ data }) => {
          setPropertyId(data.property_id)
        })
        .catch((error) => {
          console.error(error)
          setPropertyId(null)
        })
    }
  }, [leadPropertyId])

  useEffect(() => {
    if (!propertyId) {
      setProperty(null)
    } else {
      dataProvider
        .getOne('properties', { id: propertyId })
        .then(({ data }) => {
          setProperty(data)
        })
        .catch((error) => {
          console.error(error)
          setProperty(null)
        })
    }
  }, [propertyId])

  const onSuccess = () => {
    notify('Inspection Created', 'info', { smart_count: 1 }, true)
    redirect(`/leadProperties/` + leadPropertyId + `/visits`)
  }

  const onFailure = (error) => {
    notify(`An Error occured while creating inspection ${error}`, 'error', { smart_count: 1 }, true)
    refresh()
  }

  const CustomToolbar = (props) => {
    const ct = '/leadProperties/' + leadPropertyId + '/visits'
    return (
      <Toolbar {...props}>
        {permissions?.inspection.canCreate && <SaveButton onSuccess={onSuccess} onFailure={onFailure} />}
        <ListButton label="Back" basePath={ct} style={{ float: 'right' }} />
      </Toolbar>
    )
  }
  return (
    <Create {...props} record="" title="Create Inspection" resource="visits">
      <SimpleForm toolbar={<CustomToolbar />}>
        <Typography>Create Inspection</Typography>
        <FormRow>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput
              component={NumberInput}
              helperText={
                'Name:' +
                property?.name +
                ' Address:' +
                property?.address?.street +
                ' ' +
                property?.address?.street_number +
                ' ' +
                property?.address?.city +
                ' Listing:' +
                property?.listing?.title
              }
              source="property_id"
              initialValue={propertyId}
              disabled
            />
            <StyledInput
              component={TextInput}
              visible="false"
              style={{ visibility: 'hidden', height: '0px' }}
              source="lead_property_id"
              initialValue={leadPropertyId}
              disabled
            />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput
              component={TextInput}
              source="subject"
              validate={[required()]}
              initialValue={property?.id}
              disabled
              label="Subject"
            />
          </FormCol>
          <FormCol xs={12} sm={12} md={8} lg={8}>
            <StyledInput component={TextInput} source="description" initialValue="" label="Description" />
          </FormCol>
        </FormRow>
        <RunnersSchedule propertyId={propertyId} />
      </SimpleForm>
    </Create>
  )
}
